/**
 * window.$confirmを定義
 * booleanを返す
 *
 * window.$confirm('hoge', callback)
 * もしくは
 * await window.$confirm('hoge')
 */
import Modal from 'modules/Modal';

export default class WindowConfirm {
  constructor() {
    this.initialize();
  }

  initialize() {
    if (!document.getElementById('vue-window-confirm')) {
      return;
    }
    new Vue({
      el: '#vue-window-confirm',
      name: 'WindowConfirm',
      data() {
        const self = this;
        return {
          label: '',
          resolve: null,
          reject: null,
          modal: new Modal({
            onClose() {
              self.response(false);
            },
          }),
          modalId: '#vue-window-confirm-modal',
        };
      },
      mounted() {
        window.$confirm = this.confirm;
      },
      methods: {
        /**
         * @param  {String} label - 表示する文章
         * @param  {Function} callback - OK/キャンセル実行される関数(boolean)
         */
        confirm(label = '', callback = () => {}) {
          this.label = label;
          const promise = new Promise((resolve, reject) => {
            this.resolve = resolve;
            this.reject = reject;
            this.modal.open(this.modalId);
          });
          if (callback) {
            promise.then((bool) => {
              callback(bool);
            }).catch((err) => {
              throw new Error(err);
            });
          }
          return promise;
        },
        notOk() {
          this.response(false);
          this.close();
        },
        ok() {
          this.response(true);
          this.close();
        },
        close() {
          this.modal.close(this.modalId);
        },
        response(bool) {
          if (this.resolve && this.reject) {
            this.resolve(bool);
            this.resolve = null;
            this.reject = null;
          }
        },
      },
    });
  }
}
